/* Swee Choon — live estimated total on direct buffet product pages (added 25 Sep 2026).
 * Loaded only on products tagged buffet-service-charge-eligible (see layout/theme.liquid).
 * Mirrors cart rules: 10% service charge on buffet + per-pax paid upgrades only;
 * Logistics + Applicable Surcharges are once per order and excluded; 9% GST on the full order.
 * Display only — it never changes cart contents or prices. */
(function () {
  var cfg = window.SC_ESTIMATE || {};
  var BASE = Number(cfg.price) || 0;
  if (!BASE) return;
  var ONE_TIME = { 'logistics': 1, 'applicable surcharges': 1 };
  var PANEL_ID = 'sc-price-estimate';

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toLocaleString('en-SG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function r2(n) { return Math.round(n * 100) / 100; }
  function priceOf(input) {
    var lab = input.closest('label');
    var t = lab ? lab.textContent : '';
    var m = t.match(/\(\+\s*\$([\d,]+(?:\.\d+)?)\)/);
    return m ? Number(m[1].replace(/,/g, '')) : 0;
  }
  function pax() {
    var q = document.querySelector('form[action*="/cart/add"] input[name="quantity"]') || document.querySelector('input[name="quantity"]');
    var v = q ? parseInt(q.value, 10) : 0;
    return v > 0 ? v : 0;
  }
  function compute() {
    var root = document.getElementById('avpoptions-container__v2');
    if (!root) return null;
    var perPax = 0, oneTime = 0, oneTimeItems = [];
    var groups = root.querySelectorAll('.avp-option');
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      var tEl = g.querySelector('.apo-title');
      var title = tEl ? tEl.textContent.trim().toLowerCase() : '';
      var ins = g.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked');
      for (var j = 0; j < ins.length; j++) {
        var p = priceOf(ins[j]);
        if (!p) continue;
        if (ONE_TIME[title]) { oneTime += p; oneTimeItems.push(ins[j].value + ' ' + money(p)); }
        else perPax += p;
      }
      // Single-select dropdowns (if any are used later)
      var sels = g.querySelectorAll('select');
      for (var k = 0; k < sels.length; k++) {
        var o = sels[k].options[sels[k].selectedIndex];
        var mm = o && o.text.match(/\(\+\s*\$([\d,]+(?:\.\d+)?)\)/);
        if (mm) { var sp = Number(mm[1].replace(/,/g, '')); if (ONE_TIME[title]) oneTime += sp; else perPax += sp; }
      }
    }
    var n = pax();
    var buffet = r2(BASE * n);
    var upgrades = r2(perPax * n);
    var basis = r2(buffet + upgrades);
    var sc = r2(basis * 0.10);
    var sub = r2(basis + sc + oneTime);
    var gst = r2(sub * 0.09);
    return { n: n, perPax: perPax, buffet: buffet, upgrades: upgrades, sc: sc, oneTime: oneTime, oneTimeItems: oneTimeItems, sub: sub, gst: gst, total: r2(sub + gst) };
  }
  function row(label, value, strong) {
    return '<div class="sc-est-row' + (strong ? ' sc-est-strong' : '') + '"><span>' + label + '</span><span>' + value + '</span></div>';
  }
  var lastKey = '';
  function render() {
    var btn = document.querySelector('.avis-new-addcart-button') || document.querySelector('form[action*="/cart/add"] [name="add"]');
    if (!btn || !btn.parentNode) return;
    var panel = document.getElementById(PANEL_ID);
    if (!panel || panel.nextElementSibling !== btn) {
      if (panel) panel.remove();
      panel = document.createElement('div');
      panel.id = PANEL_ID;
      panel.setAttribute('aria-live', 'polite');
      btn.parentNode.insertBefore(panel, btn);
      lastKey = '';
    }
    var c = compute();
    if (!c) return;
    var key = JSON.stringify(c);
    if (key === lastKey) return;
    lastKey = key;
    var h = '<div class="sc-est-title">Estimated total' + (c.n ? ' \u00b7 ' + c.n + ' pax' : '') + '</div>';
    h += row('Buffet (' + money(BASE) + ' \u00d7 ' + c.n + ')', money(c.buffet));
    if (c.upgrades > 0) h += row('Paid upgrades (' + money(c.perPax) + ' \u00d7 ' + c.n + ')', money(c.upgrades));
    h += row('10% service charge', money(c.sc));
    h += row('Delivery &amp; surcharges (once per order)', money(c.oneTime));
    h += '<div class="sc-est-line"></div>';
    h += row('Subtotal', money(c.sub));
    h += row('9% GST', money(c.gst));
    h += row('Estimated total', money(c.total), true);
    h += '<div class="sc-est-note">Final amount is confirmed at checkout.</div>';
    panel.innerHTML = h;
  }
  function injectCss() {
    if (document.getElementById('sc-est-css')) return;
    var s = document.createElement('style');
    s.id = 'sc-est-css';
    s.textContent =
      '#avp-productoption-total-add,.avp-productoption-total-add{display:none!important}' +
      '#' + PANEL_ID + '{border:1.5px solid #ae0a2b;border-radius:8px;background:#fff;padding:14px 16px;margin:6px 0 14px;font-family:Jost,sans-serif;font-size:14px;color:#333;line-height:1.5}' +
      '#' + PANEL_ID + ' .sc-est-title{color:#ae0a2b;font-weight:700;letter-spacing:.06em;text-transform:uppercase;font-size:13px;margin-bottom:8px}' +
      '#' + PANEL_ID + ' .sc-est-row{display:flex;justify-content:space-between;gap:12px;padding:2px 0}' +
      '#' + PANEL_ID + ' .sc-est-row span:last-child{white-space:nowrap}' +
      '#' + PANEL_ID + ' .sc-est-line{border-top:1px solid #eadada;margin:6px 0}' +
      '#' + PANEL_ID + ' .sc-est-strong{font-weight:700;font-size:16px;color:#ae0a2b;padding-top:4px}' +
      '#' + PANEL_ID + ' .sc-est-note{font-size:12px;color:#777;margin-top:6px;font-style:italic}';
    document.head.appendChild(s);
  }
  function schedule() { setTimeout(render, 60); setTimeout(render, 400); }
  function start() {
    injectCss();
    document.addEventListener('change', schedule, true);
    document.addEventListener('input', schedule, true);
    document.addEventListener('click', schedule, true);
    setInterval(render, 1000); // safety net for app redraws
    render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
